const prefixes = {
  certificateAppeal: process.env.REACT_APP_QR_API + "/qr-code/",
};

export const apiConfig = {
  prefixes,
};
